import script from "./CommunitySection.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunitySection.vue?vue&type=script&setup=true&lang=js"

import "./CommunitySection.vue?vue&type=style&index=0&id=c170f208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c170f208"]])

export default __exports__